/**
 * ShareIcon - Icon representing share/export action
 * Feature: 080-critique-sharing
 *
 * Standard share icon with arrow pointing up-right
 */

import type { IconProps } from './IconTypes';

export function ShareIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Share',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Share box with arrow */}
      <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" />
      <polyline points="16 6 12 2 8 6" />
      <line x1="12" y1="2" x2="12" y2="15" />
    </svg>
  );
}
